import "./../estadisticas.scss";
import React, { useEffect, useState } from "react";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import DataTablePaginacionExterna from "../../../atoms/datatable/DataTablePaginacionExterna";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import { getAccesosWeb } from "../../../services/EstadisticasService";

const AccesosWeb = ({ setZona }) => {

  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [data, setData] = useState();
  const [totalPages, setTotalPages] = useState(0);


  useEffect(() => {
    
    setLoading(true)
    getAccesosWeb(currentPage, pageSize).then((data) => {
      
      
      setData(data);
      setTotalPages(data.totalPages);
      setLoading(false)
    });
  }, [currentPage, pageSize]);


  return (
    <>

      <div className="container containerUsuariosConectados">
      {/*<TituloCard clases={"mb-3 mt-2 d-flex justify-content-center "} tipo="tituloModal" titulo={"Listado de Accesos a la Web"} />*/}
      <h3 className="tituloPaginaAdmin">Listado de Accesos a la Web</h3>
      {}
        {data?.content?.length !== 0 ? (<>
          {loading? (<div className="">
            <SpinnerCircle />
            </div>) : (<>
            <DataTablePaginacionExterna
              data={data}
              columnas={[
                ...ConstantesTabla.columnasAccesosWeb,
              ]}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              totalPages={totalPages}
            />
            <div className="my-2 row d-flex justify-content-center">
              <div className="col-3">
                <button
                  className={`btnRed rounded p-1`}
                  type="button"
                  onClick={() => { setZona({ "links": true }) }}
                >
                  Volver
                </button>
              </div>
            </div>
          </>)}
        </>) : (<>
        <div className="text-center">
        <span className="">No se han registrado accesos a la Web.</span>
        <div className="my-2 row d-flex justify-content-center">
              <div className="col-3">
                <button
                  className={`btnRed rounded p-1`}
                  type="button"
                  onClick={() => { setZona({ "links": true }) }}
                >
                  <i className="fa-solid fa-rotate-left"></i>{" "}
                  Volver
                </button>
              </div>
            </div>
        </div>
       </>)}





      </div >


    </>

  );
};
export default AccesosWeb;
